import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#5757b0',
      light: '#7777d0',
      dark: '#4545a0',
      contrastText: '#fff'
    },
    secondary: {
      main: '#f59e0b'
    },
    background: {
      default: '#f7f7ff',
      paper: '#ffffff'
    },
    text: {
      primary: '#222',
      secondary: '#666'
    }
  },
  shape: {
    borderRadius: 8
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
    h4: {
      fontWeight: 600
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8
        }
      }
    },
    MuiDrawer: {
      defaultProps: {
        anchor: 'right'
      }
    }
  }
});

export default theme;
